var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54594 14.643L6.989 16.7222L4.95341 16.7652C4.34506 15.6369 4 14.3459 4 12.974C4 11.6475 4.32263 10.3965 4.8945 9.29492H4.89494L6.70719 9.62717L7.50106 11.4285C7.33491 11.913 7.24434 12.433 7.24434 12.974C7.24441 13.5613 7.35078 14.124 7.54594 14.643Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8602 11.4795C19.9521 11.9634 20 12.4632 20 12.974C20 13.5467 19.9398 14.1054 19.8251 14.6443C19.4357 16.4782 18.4181 18.0795 17.0084 19.2127L17.008 19.2122L14.7253 19.0958L14.4023 17.0791C15.3377 16.5305 16.0687 15.672 16.4537 14.6443H12.1759V11.4795H16.5161H19.8602Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0079 19.2118L17.0083 19.2122C15.6373 20.3142 13.8958 20.9735 12 20.9735C8.95337 20.9735 6.30459 19.2707 4.95337 16.7648L7.5459 14.6426C8.22149 16.4456 9.96084 17.7292 12 17.7292C12.8764 17.7292 13.6976 17.4922 14.4021 17.0786L17.0079 19.2118Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1064 6.81538L14.5148 8.93713C13.7855 8.48132 12.9235 8.21801 12 8.21801C9.91475 8.21801 8.14287 9.56041 7.50113 11.4281L4.89497 9.29451H4.89453C6.22597 6.72748 8.90816 4.97363 12 4.97363C13.9411 4.97363 15.7209 5.66507 17.1064 6.81538Z",
    fill: "#F14336"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.094912724e3e8f8f1dc7db1a17c63b8f.svg";
export { ForwardRef as ReactComponent };